import React from 'react';
import { Icon, Message } from 'semantic-ui-react';
import { Resultados } from 'src/api/protocolo';

export type Props = Readonly<Resultados<'alumnoEstaRestringido'>>;

const MensajeRestriccion: React.FunctionComponent<Props> = props => {
    const { restricciones } = props;
    const arreglo = Object.entries(restricciones) // Array<[puntaje, true]>
        .filter(t => t[1])
        .map(([restriccion]) => restriccion);
    if (arreglo.length === 0) return null;
    return (
        <Message negative size='large' icon>
            <Icon name='ban' />
            <Message.Content>{mensaje(arreglo)}</Message.Content>
        </Message>
    );
};

function mensaje(arreglo: string[]) {
    const [r1, r2, r3] = arreglo.map(x => <b key={x}>{x}</b>);
    const texto = 'El alumno se encuentra restringido de';
    if (r3) {
        return (
            <>
                {texto} {r1}, {r2} y {r3}.
            </>
        );
    }
    if (r2) {
        return (
            <>
                {texto} {r1} y {r2}.
            </>
        );
    }
    if (r1) {
        return (
            <>
                {texto} {r1}.
            </>
        );
    }
    return null;
}

export default MensajeRestriccion;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/componentes/MensajeRestringidos.tsx